import { render } from "./ModalAddNote.vue?vue&type=template&id=10a34d94"
import script from "./ModalAddNote.vue?vue&type=script&lang=js"
export * from "./ModalAddNote.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__